var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Basic")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          [
            _c("div", { staticClass: "bj-row mt10 mb10" }, [
              _c("div", { staticClass: "bj-col-24" }, [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ReturnOrderText")) +
                        _vm._s(_vm.$t("goodsBrand.page.Status"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.RETURN_ORDER_STATUS.bjGet(_vm.form.status))
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessAfterCsgReturn.table.reference"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.remark)),
                  ]),
                ]),
              ]),
            ]),
            _c("BjDivider", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
                  " "
              ),
            ]),
            _c(
              "el-table",
              {
                attrs: {
                  data: [_vm.form],
                  border: "",
                  script: "",
                  "max-height": "600",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BjDialogListConfig.SKUcode"),
                    prop: "standardSkuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BjDialogListConfig.SKUname"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.main.totalQty"),
                    prop: "planQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessAfterCsgReturn.table.backInventoryQty"
                    ),
                    prop: "backInventoryQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessAfterCsgReturn.table.backInventoryRemark"
                    ),
                    prop: "backInventoryRemark",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.table.damagedQty"),
                    prop: "damagedQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessAfterCsgReturn.table.damagedRemark"),
                    prop: "damagedRemark",
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.pictureMsg"))),
      ]),
      _c("div", { staticClass: "mt20" }, [
        _c(
          "div",
          { staticClass: "flex" },
          _vm._l(
            _vm.form.thirdPartyReturnOrderMaterialList,
            function (imageUrl, index) {
              return _c(
                "div",
                { key: index, staticClass: "imageViewer" },
                [
                  _c("BjKeyImage", {
                    staticStyle: { margin: "10px" },
                    attrs: {
                      height: "148px",
                      width: "148px",
                      url: imageUrl.detailImage,
                      preview: "",
                    },
                  }),
                  _c("div", { staticClass: "flex flex-spacearound" }, [
                    _c("i", {
                      staticClass: "el-icon-download yellow",
                      on: {
                        click: function ($event) {
                          return _vm.downloadImage(imageUrl.detailImage)
                        },
                      },
                    }),
                  ]),
                ],
                1
              )
            }
          ),
          0
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }